/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Button from "../Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import trans, { isRTL } from "../../../utils";
import useIsMobile from "../../../hooks/useIsMobile";

export default function OffcanvasFooter({
  addData,
  submitAttempt,
  text,
  setIsShown,
  onClose,
  onClick,
}) {
  let { handleClose } = useContext(popupcontext);
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <div className="form-snag-footer-sticky m-0">
        <div className="offcanvas-footer-body gap-8">
          <Button type="primary" htmlType="submit" text={trans("Save")} />
          <Button
            type="default"
            htmlType="button"
            text={trans("Cancel")}
            onClick={() => {
              handleClose("form");
              onClose?.();
            }}
          />
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="offcanvas-footer m-0">
        <div className="offcanvas-footer-body gap-8">
          {!text ? (
            <Button type="primary" htmlType="submit" text={trans("Save")} />
          ) : (
            <Button
              type="primary"
              htmlType="button"
              text={trans("Show")}
              onClick={() => {
                if (onClick) {
                  onClick();
                } else {
                  setIsShown(true);
                  handleClose("form");
                }
              }}
            />
          )}
          <Button
            type="default"
            htmlType="button"
            text={trans("Cancel")}
            onClick={() => {
              handleClose("form");
              onClose?.();
            }}
          />
        </div>
        {submitAttempt && !addData.isValid ? (
          <div className={`validation ${isRTL ? "text-start" : "text-end"}`}>
            {trans("Please Check Required Inputs")}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
